import React, { useCallback } from 'react';
import { useForm, useFormState } from 'react-final-form';
import moment from 'moment';

import { apiClient } from '../../../../http';
import { useSeason } from '../../../../common/inputs/SeasonSelector';
import { YearViewDatePickerInput } from '../../../../common/inputs/YearViewDatePicker';

export default ({ setValidating }) => {
  const { values } = useFormState();
  const form = useForm();
  const seasonId = useSeason();

  const validatingDate = useCallback(
    /**
     * @param {string[]} toValidate
     */
    async (toValidate) => {
      const recurrenceDatesValidTmp = values.recurrenceDatesValid || {};
      const errors = [];
      const toFetch = [];
      toValidate.forEach(date => {
        if (date in recurrenceDatesValidTmp) {
          // if error exists on cache
          recurrenceDatesValidTmp[date] && errors.push(recurrenceDatesValidTmp[date]);
        } else {
          toFetch.push(date);
        }
      });

      if (toFetch.length) {
        const response = await apiClient({
          url: `/arenaslots/validation`,
          method: 'POST',
          data: { slots: values.slots, dates: toFetch, officeId: values.officeId, seasonId },
        });

        toFetch.forEach(date => {
          const error = response.data.errors.find(d => moment(d.date).isSame(date, 'day'));
          recurrenceDatesValidTmp[date] = error;
          if (error) {
            errors.push(error);
          }
        });
        form.change('recurrenceDatesValid', recurrenceDatesValidTmp);
      }

      return errors;
    },
    [values.slots, values.officeId, values.recurrenceDatesValid, form, seasonId]
  );

  return <YearViewDatePickerInput source="recurrenceDates" validatingDate={validatingDate} setValidating={setValidating} />;
};
